import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

type Size = 'small' | 'medium';

export interface OpColorOption extends HTMLElement {
  size?: Size;
  color: string; // hex color value
  selected: boolean;
  disabled: boolean;
  showLabel: boolean;
  label: string;
  textVariant?: string;
}

const OpColorOption = createWrapper<OpColorOption>('op-color-option');

export default OpColorOption;
